export default __webpack_public_path__ + "static/media/uminhoon.e7bfd9bf.png";